import { render } from "./MyCalendar.vue?vue&type=template&id=fdcc5402"
import script from "./MyCalendar.vue?vue&type=script&lang=js"
export * from "./MyCalendar.vue?vue&type=script&lang=js"

import "./MyCalendar.vue?vue&type=style&index=0&id=fdcc5402&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__